var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlatnoscPrzyOdbiorze48 = function SvgPlatnoscPrzyOdbiorze48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "platnosc_przy_odbiorze_48_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".platnosc_przy_odbiorze_48_svg__st0{fill:none;stroke:#010101;stroke-width:1.3;stroke-miterlimit:10}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.9 32c-.2-.7-.7-1.3-1.4-1.7-.7-.4-1.4-.4-2.1-.2l-9.3 2.3c.1-.2.1-.3.1-.5.2-.7.1-1.5-.4-2.1-.4-.6-1-1.1-1.7-1.3-9-2.3-9.4-2.2-9.5-2.2-.4.1-4 1.2-5.7 1.8-.1-.4-.4-.7-.8-.8-.3-.2-.8-.2-1.1 0l-3.6 1.4c-.3.1-.4.4-.3.7.1.3.5.4.7.3l3.6-1.4h.3c.1 0 .1.1.2.2l3.8 10.2c.1.2 0 .4-.2.4-.3.1-.4.4-.3.7.1.2.3.4.5.4h.2c.7-.3 1.1-1.1.9-1.8.2-.1.5-.2.6-.2.2 0 1.6.2 3 .4 4.1.6 6.3.8 7.3.8h.4c.7-.2 12.5-3.6 13.1-3.8.7-.2 1.3-.7 1.6-1.4.2-.8.3-1.5.1-2.2zm-1.2 1.6c-.2.4-.6.7-1 .8-.1 0-12.3 3.6-13 3.8-.6.1-4.9-.5-7.3-.8-1.9-.2-2.9-.4-3.1-.4-.3 0-.5.1-.9.3l-3.1-8.1c2.1-.7 5.1-1.6 5.3-1.7.5.1 5.9 1.3 9.2 2.2.4.1.8.4 1.1.8.2.4.3.9.2 1.3-.2.9-1.1 1.5-2 1.3l-5.5-1.3c-.3-.1-.6.1-.7.4-.1.3.1.6.4.7l5.5 1.3c.2.1.4.1.6.1.1 0 .2.1.3 0l12-2.9c.4-.1.9-.1 1.3.1s.7.6.8 1c.1.2.1.7-.1 1.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "platnosc_przy_odbiorze_48_svg__st0",
    cx: 31.5,
    cy: 21.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "platnosc_przy_odbiorze_48_svg__st0",
    cx: 20,
    cy: 18,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "platnosc_przy_odbiorze_48_svg__st0",
    cx: 28,
    cy: 12,
    r: 3.5
  })))));
};
export default SvgPlatnoscPrzyOdbiorze48;